module.exports = __webpack_public_path__ + "static/media/photo-9-sm.352df6ed.jpeg";